/*
  Sportconic marketing-secties — interacties.
  - FAQ + why-you accordeons.
  - Reviews: tekstreviews uit de feed (window.SPReviews) renderen/pagineren/filteren,
    media-muur filteren + uitklappen, en een lightbox (foto/video/tekst) via delegatie.
  Eén IIFE; geen globale lekkage.
*/
(function () {
  if (window.__spMarketingInit) return;
  window.__spMarketingInit = true;

  var NL_MONTHS = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var STAR = '<svg viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
  var VERIFIED = '<svg viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg>';

  function escAttr(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  /* maanden: 1-gebaseerde lijst uit data-maanden (lege eerste positie); patroon met %d/%m/%j
     uit data-datum-patroon. Ontbreken die (oude cache), dan de Nederlandse notatie. */
  function fmtDate(d, maanden, patroon) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d || ''); if (!m) return d || '';
    var dag = String(parseInt(m[3], 10)), mnd = parseInt(m[2], 10);
    if (maanden && maanden.length === 13 && patroon) {
      return patroon.replace('%d', dag).replace('%m', maanden[mnd] || '').replace('%j', m[1]);
    }
    return dag + ' ' + (NL_MONTHS[mnd - 1] || '') + ' ' + m[1];
  }

  function init() {
    document.querySelectorAll('.sp-faq .faq-card').forEach(function (card) {
      card.addEventListener('click', function () { card.classList.toggle('open'); });
    });
    document.querySelectorAll('.sp-whyyou .why-acc-item').forEach(function (item) {
      item.addEventListener('click', function () { item.classList.toggle('open'); });
    });
    document.querySelectorAll('.sp-reviews').forEach(setupReviews);
    setupCompareAtc();
  }

  /* ── Vergelijkingstabel: "In winkelwagen" op de uitgelichte kaart klikt de échte
     koopknop van de hoofdsectie aan (zelfde pad als de sticky mobiele knop) — zo
     lopen gratis cadeaus vanzelf mee via de bestaande submit-logica in
     sportconic-product.js. Een eventueel al aangevinkte betaalde toevoeging
     (smeerolie) staat al los in de cart, ongeacht welke knop de hoofdorder plaatst. */
  function setupCompareAtc() {
    document.querySelectorAll('[data-cmp-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mainSubmit = document.querySelector('.sportconic-product .product-form__submit');
        if (!mainSubmit) return;
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'compare_table_add_to_cart', product_handle: btn.getAttribute('data-cmp-product') || '' });
        } catch (e) { /* analytics mag nooit de add-to-cart blokkeren */ }
        mainSubmit.click();
      });
    });
  }

  function setupReviews(sec) {
    var written = sec.querySelector('.rv-written');
    var loadBtn = sec.querySelector('.rv-loadmore-btn');
    var clearBtn = sec.querySelector('.rv-clearfilter');
    var note = sec.querySelector('.rv-filternote');
    var bars = [].slice.call(sec.querySelectorAll('[data-filter-rating]'));
    var tiles = [].slice.call(sec.querySelectorAll('.rv-wall .rv-tile[data-lb]'));
    var wallMax = tiles.filter(function (t) { return !t.classList.contains('rv-hidden'); }).length || tiles.length;
    var seeallBtns = [].slice.call(sec.querySelectorAll('[data-reveal-media]'));
    var collapseBtns = [].slice.call(sec.querySelectorAll('[data-collapse-media]'));
    var feedKey = sec.getAttribute('data-feed-key');
    var locale = sec.getAttribute('data-locale');
    var verifiedLabel = sec.getAttribute('data-verified-label') || 'Verified';
    var maanden = (sec.getAttribute('data-maanden') || '').split(',');
    var datumPatroon = sec.getAttribute('data-datum-patroon') || '';
    var localizedFeed = (locale && window.SPReviews) ? window.SPReviews[feedKey + '-' + locale] : null;
    var feed = (localizedFeed && localizedFeed.length) ? localizedFeed
      : ((window.SPReviews && window.SPReviews[feedKey]) ? window.SPReviews[feedKey] : null);
    var initial = parseInt(written && written.getAttribute('data-initial'), 10) || 6;
    var filter = null, shown = 0, wallExpanded = false;
    /* Op mobiel (zelfde grens als de CSS-breakpoint) is de muur een horizontale
       scroller zonder "alle bekijken"-knop (die is daar bewust verborgen) — dus
       moet daar altijd de volledige muur staan, anders zit je vast op wallMax. */
    var isMobileWall = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    var setHidden = function (el, h) { if (!el) return; if (h) el.setAttribute('hidden', ''); else el.removeAttribute('hidden'); };

    /* ── media-muur: toont wallMax (gefilterd); "+"-tegel/"alle bekijken" klapt de muur uit (desktop).
       Klikken op een fototegel opent de lightbox-viewer (zie setupLightbox). ── */
    function renderWall(rating) {
      var shownC = 0, matchTotal = 0;
      tiles.forEach(function (t) {
        var m = (rating == null) || t.getAttribute('data-rating') === String(rating);
        if (!m) { t.classList.add('rv-filterhide'); t.classList.remove('rv-hidden'); return; }
        matchTotal++;
        t.classList.remove('rv-filterhide');
        if (wallExpanded || isMobileWall || shownC < wallMax) { t.classList.remove('rv-hidden'); shownC++; }
        else t.classList.add('rv-hidden');
      });
      seeallBtns.forEach(function (b) { b.style.display = (!wallExpanded && !isMobileWall && matchTotal > wallMax) ? '' : 'none'; });
      collapseBtns.forEach(function (b) { setHidden(b, isMobileWall || !wallExpanded || matchTotal <= wallMax); });
    }
    seeallBtns.forEach(function (el) {
      el.addEventListener('click', function (e) { e.stopPropagation(); wallExpanded = true; renderWall(filter); });
    });
    collapseBtns.forEach(function (el) {
      el.addEventListener('click', function (e) { e.stopPropagation(); wallExpanded = false; renderWall(filter); });
    });

    /* ── tekstkaart-HTML uit een feed-item {i,r,n,d,t,v,p} ── */
    function cardHTML(r) {
      var rating = r.r || 5, stars = '';
      for (var s = 0; s < rating; s++) stars += STAR;
      var date = fmtDate(r.d, maanden, datumPatroon);
      var meta = (r.n ? '<b>' + escAttr(r.n) + '</b>' : '') + (date ? ' · ' + escAttr(date) : '');
      var thumb = r.p ? '<div class="rv-wcard-thumbs"><div class="rv-wcard-thumb"><img class="g" src="' + escAttr(r.p) + '" alt="" loading="lazy"></div></div>' : '';
      var verif = r.v ? '<span class="rv-wcard-verified">' + VERIFIED + escAttr(verifiedLabel) + '</span>' : '';
      // Alleen klikbaar (lightbox) als er een foto bij zit.
      var lbAttrs = r.p ? ' data-lb data-handle="loox-' + escAttr(String(r.i || '').toLowerCase()) + '" data-type="photo" data-img="' + escAttr(r.p) + '" data-video="" data-name="' + escAttr(r.n || '') + '" data-sub="' + escAttr(date) + '" data-text="' + escAttr(r.t || '') + '" data-verified="' + (r.v ? '1' : '') + '"' : '';
      return '<div class="rv-wcard" data-rating="' + rating + '"' + lbAttrs + '>'
        + '<div class="rv-wcard-stars">' + stars + '</div>'
        + '<div class="rv-wcard-text">' + escAttr(r.t || '') + '</div>'
        + thumb
        + '<div class="rv-wcard-meta"><span>' + meta + '</span>' + verif + '</div>'
        + '</div>';
    }

    /* Lange tekst-only reviews (geen foto → geen lightbox) uitklapbaar maken. */
    function enhanceText() {
      [].slice.call(written.querySelectorAll('.rv-wcard:not([data-lb])')).forEach(function (c) {
        if (c.getAttribute('data-clamp-done')) return;
        c.setAttribute('data-clamp-done', '1');
        var txt = c.querySelector('.rv-wcard-text');
        if (!txt || txt.scrollHeight - txt.clientHeight <= 2) return;
        c.classList.add('rv-clampable');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rv-expand-btn';
        btn.setAttribute('aria-label', 'Lees meer');
        btn.innerHTML = '<svg viewBox="0 0 24 24" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>';
        txt.insertAdjacentElement('afterend', btn);
        c.addEventListener('click', function () {
          var expanded = c.classList.toggle('rv-expanded');
          btn.setAttribute('aria-label', expanded ? 'Lees minder' : 'Lees meer');
        });
      });
    }
    function renderNormal() {
      filter = null; wallExpanded = false;
      bars.forEach(function (b) { b.classList.remove('active'); });
      setHidden(clearBtn, true); setHidden(note, true);
      renderWall(null);
      if (feed) { shown = Math.min(initial, feed.length); written.innerHTML = feed.slice(0, shown).map(cardHTML).join(''); setHidden(loadBtn, shown >= feed.length); }
      else setHidden(loadBtn, true);
      enhanceText();
    }
    function loadMore() {
      if (!feed) return;
      shown = Math.min(feed.length, shown + initial);
      written.innerHTML = feed.slice(0, shown).map(cardHTML).join('');
      setHidden(loadBtn, shown >= feed.length);
      enhanceText();
    }
    function applyFilter(rating) {
      filter = rating; wallExpanded = false;
      bars.forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-filter-rating') === String(rating)); });
      renderWall(rating);
      var n = 0;
      if (feed) { var ms = feed.filter(function (r) { return (r.r || 5) === rating; }); n = ms.length; written.innerHTML = ms.map(cardHTML).join(''); }
      else { [].slice.call(written.querySelectorAll('.rv-wcard')).forEach(function (c) { var m = c.getAttribute('data-rating') === String(rating); c.style.display = m ? '' : 'none'; if (m) n++; }); }
      setHidden(loadBtn, true); setHidden(clearBtn, false);
      enhanceText();
      if (note) { if (n === 0) { note.textContent = note.getAttribute('data-empty') || ''; setHidden(note, false); } else setHidden(note, true); }
    }

    renderNormal();
    if (loadBtn) loadBtn.addEventListener('click', loadMore);
    if (clearBtn) clearBtn.addEventListener('click', function () { if (!feed) { [].slice.call(written.querySelectorAll('.rv-wcard')).forEach(function (c) { c.style.display = ''; }); } renderNormal(); });
    bars.forEach(function (b) { b.addEventListener('click', function () { var r = parseInt(b.getAttribute('data-filter-rating'), 10); if (filter === r) renderNormal(); else applyFilter(r); }); });

    setupTileClips(sec);
    setupLightbox(sec);
  }

  /* ── Videotegels: de korte klip speelt stil en herhalend, maar pas zodra de tegel
     in beeld komt. Zo kost een pagina met meerdere videoreviews niets zolang je er
     nog niet bent, en staat een tegel buiten beeld ook weer stil. ── */
  function setupTileClips(sec) {
    var clips = [].slice.call(sec.querySelectorAll('.rv-tile-clip[data-src]'));
    if (!clips.length) return;
    var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function laad(v) {
      if (v.getAttribute('src')) return;
      /* Altijd minstens het eerste frame ophalen. Weigert de browser autoplay
         (spaarstand, databesparing), dan staat er zo nog steeds beeld in de tegel
         in plaats van een leeg vlak. */
      v.preload = 'metadata';
      v.src = v.getAttribute('data-src');
    }
    if (!('IntersectionObserver' in window)) { clips.forEach(laad); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (!e.isIntersecting) { if (!v.paused) v.pause(); return; }
        laad(v);
        if (stil) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }, { rootMargin: '200px 0px', threshold: 0.1 });
    clips.forEach(function (v) { io.observe(v); });

    /* Zolang de lightbox openstaat bedekt die de muur; de klips eronder hoeven dan
       niet door te decoderen. De lightbox roept dit aan bij openen en sluiten. */
    sec.spKlips = {
      pauzeer: function () { clips.forEach(function (v) { if (!v.paused) { v.setAttribute('data-hervat', ''); v.pause(); } }); },
      hervat: function () {
        if (stil) return;
        clips.forEach(function (v) {
          if (!v.hasAttribute('data-hervat')) return;
          v.removeAttribute('data-hervat');
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        });
      }
    };
  }

  /* ── Lightbox via delegatie (werkt op server- én JS-gerenderde kaarten) ── */
  function setupLightbox(sec) {
    var lb = sec.querySelector('.rv-lb');
    if (!lb) return;
    var imgEl = lb.querySelector('.rv-lb-img');
    var videoEl = lb.querySelector('.rv-lb-video');
    var starsEl = lb.querySelector('.rv-lb-stars'), quoteEl = lb.querySelector('.rv-lb-quote');
    var nameEl = lb.querySelector('.rv-lb-author-name'), subEl = lb.querySelector('.rv-lb-author-sub');
    var verifiedEl = lb.querySelector('.rv-lb-author-verified'), counterEl = lb.querySelector('.rv-lb-counter');
    var stageEl = lb.querySelector('.rv-lb-stage');
    var prev = lb.querySelector('.rv-lb-prev'), next = lb.querySelector('.rv-lb-next');
    var items = [], idx = 0;

    function collect() {
      var seen = {}; items = [];
      [].slice.call(sec.querySelectorAll('.rv-wall .rv-tile[data-lb]')).forEach(function (el) {
        if (el.classList.contains('rv-filterhide')) return;
        var h = el.getAttribute('data-handle') || ('_' + items.length);
        if (seen[h] === undefined) { seen[h] = items.length; items.push(el); }
      });
      [].slice.call(sec.querySelectorAll('.rv-written [data-lb]')).forEach(function (el) {
        if (el.offsetParent === null) return;
        var h = el.getAttribute('data-handle') || ('_' + items.length);
        if (seen[h] === undefined) { seen[h] = items.length; items.push(el); }
      });
    }
    function render(i) {
      var el = items[i]; if (!el) return; idx = i;
      var img = el.getAttribute('data-img');
      var vid = el.getAttribute('data-video');
      if (stageEl) stageEl.classList.toggle('rv-lb-nomedia', !img && !vid);
      /* Bij een videoreview zie je de video zelf, zonder foto eroverheen. De vorige
         video altijd stoppen en leegmaken, anders blijft hij doorspelen als je naar
         de volgende review swipet. Openen is een klik, dus afspelen mét geluid mag;
         weigert de browser dat toch, dan blijft de speler gewoon staan. */
      if (videoEl) { videoEl.pause(); videoEl.removeAttribute('src'); videoEl.load(); }
      if (vid && videoEl) {
        videoEl.preload = 'auto';
        videoEl.src = vid;
        videoEl.removeAttribute('hidden');
        if (imgEl) imgEl.setAttribute('hidden', '');
        var p = videoEl.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        if (videoEl) videoEl.setAttribute('hidden', '');
        if (img) { if (imgEl) { imgEl.src = img; imgEl.alt = el.getAttribute('data-name') || ''; imgEl.removeAttribute('hidden'); } }
        else { if (imgEl) imgEl.setAttribute('hidden', ''); }
      }
      var rating = parseInt(el.getAttribute('data-rating'), 10) || 5, s = '';
      for (var n = 0; n < rating; n++) s += STAR;
      if (starsEl) starsEl.innerHTML = s;
      if (quoteEl) { var t = el.getAttribute('data-text'); quoteEl.textContent = t || ''; }
      if (nameEl) nameEl.textContent = el.getAttribute('data-name') || '';
      if (subEl) subEl.textContent = el.getAttribute('data-sub') || '';
      if (verifiedEl) { if (el.getAttribute('data-verified')) verifiedEl.removeAttribute('hidden'); else verifiedEl.setAttribute('hidden', ''); }
      if (counterEl) counterEl.textContent = (i + 1) + ' / ' + items.length;
      if (prev) prev.style.display = items.length > 1 ? '' : 'none';
      if (next) next.style.display = items.length > 1 ? '' : 'none';
    }
    /* Eenmalig (per browser) een korte "duw"-animatie op de foto laten zien, zodat
       bezoekers leren dat ze kunnen swipen — alleen op mobiel, alleen als er meer
       dan 1 foto is, en nooit als reduced-motion aanstaat. */
    function maybeShowSwipeHint() {
      if (items.length <= 1 || !imgEl) return;
      if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      try {
        if (localStorage.getItem('sp_lb_swipe_hint_seen')) return;
        localStorage.setItem('sp_lb_swipe_hint_seen', '1');
      } catch (e) { return; }
      setTimeout(function () {
        imgEl.classList.add('rv-swipe-hint');
        imgEl.addEventListener('animationend', function handler() {
          imgEl.classList.remove('rv-swipe-hint');
          imgEl.removeEventListener('animationend', handler);
        });
      }, 450);
    }
    function open(el) { collect(); var i = items.indexOf(el); if (i < 0) i = 0; render(i); lb.removeAttribute('hidden'); document.documentElement.style.overflow = 'hidden'; if (sec.spKlips) sec.spKlips.pauzeer(); maybeShowSwipeHint(); }
    function close() { lb.setAttribute('hidden', ''); document.documentElement.style.overflow = ''; if (videoEl) { videoEl.pause(); videoEl.removeAttribute('src'); videoEl.load(); } if (sec.spKlips) sec.spKlips.hervat(); }
    function step(d) { render((idx + d + items.length) % items.length); }

    sec.addEventListener('click', function (e) {
      var t = e.target.closest('[data-lb]');
      if (t && !t.closest('.rv-lb') && sec.contains(t)) open(t);
    });
    var cb = lb.querySelector('.rv-lb-close'); if (cb) cb.addEventListener('click', close);
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hasAttribute('hidden')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft' && items.length > 1) step(-1);
      else if (e.key === 'ArrowRight' && items.length > 1) step(1);
    });
    var tx = 0, ty = 0, swipeLock = null, onVideo = false;
    if (stageEl) {
      stageEl.addEventListener('touchstart', function (e) {
        if (e.touches.length > 1) return; // 2 vingers: laat de browser dat afhandelen (pinch)
        /* Begint de aanraking op de videospeler, dan swipen we niet: het slepen
           over de tijdbalk zou anders naar de volgende review springen. */
        onVideo = !!(e.target && e.target.closest && e.target.closest('.rv-lb-video'));
        tx = e.touches[0].clientX; ty = e.touches[0].clientY; swipeLock = null;
      }, { passive: true });
      /* Niet-passief: zodra duidelijk is dat de beweging horizontaal is (swipe),
         blokkeren we het standaard touch-gedrag van de browser actief. Zonder dit
         kan snel achter elkaar swipen door de browser als dubbeltik/pinch worden
         opgevat, waardoor er ongewenst wordt ingezoomd. */
      stageEl.addEventListener('touchmove', function (e) {
        if (onVideo || e.touches.length > 1 || swipeLock === 'y') return;
        var dx = e.touches[0].clientX - tx, dy = e.touches[0].clientY - ty;
        if (swipeLock === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) swipeLock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (swipeLock === 'x') e.preventDefault();
      }, { passive: false });
      stageEl.addEventListener('touchend', function (e) { if (onVideo) return; var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 50 && items.length > 1) step(dx < 0 ? 1 : -1); }, { passive: true });
    }
  }

  // Pas initialiseren op DOMContentLoaded — dan zijn alle defer-scripts (incl. de reviews-feed) klaar.
  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
